import '../styles/index.scss'

history.scrollRestoration = "manual";
const isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
const isMobile = $(window).width() < 1024;

const navBtn = document.querySelector('.nav__hamburger');
const hamburgerBtn = document.querySelector('.nav__hamburger-btn');
const closeBtn = document.querySelector('.nav__close-btn');
const menu = document.querySelector('.menu');
const header = document.querySelector('.header');

var viewportHeight = window.innerHeight;
const healthMonitoringHeight = $('.health-monitoring').height();
const headerHeight = $('.header').height();
const navHeight = $('.nav').height();
const footerHeight = $('.footer').height();

const slickSlider = $('.health-monitoring__slick');

// last position of scroll, to determine if user is scrolling up or down
var lastPositionTop = 0;
// the direction the user is scrolling on the body (up/down)
var directionDown = true
// block the slider from escaping the lock
var lockEscapeSlider = false
// block locking of the slider
var blockSliderLocking = true
// is the page locked to the slider
var isLockedToSlider = false

const player = new Plyr('#player')
const player2 = new Plyr('#player2')
const player3 = new Plyr('#player3')

function blockLocking(time) {
  blockSliderLocking = true
  setTimeout(() => {
    blockSliderLocking = false
  }, time)
}

function lockEscape(time, unlock) {
  lockEscapeSlider = true
  setTimeout(() => {
    lockEscapeSlider = false
  }, time)
  if (unlock) isLockedToSlider = false
}

$(document).ready(function () {
  $(window).scrollTop(0);

  if (isMobile) $('.health-monitoring').css('pointer-events', 'all')
  if (isSafari && !isMobile) {
    $('.health-monitoring').css('pointer-events', 'all')
    $('.slick-prev').css({ 'top': '45%', 'left': '-60px' })
    $('.slick-next').css({ 'top': '45%', 'right': '-60px' })
  }
  setTimeout(() => {
    blockSliderLocking = false
  }, 2000)
});

$(document).on('scroll', function (e) {
  const currentPositionTop = $(window).scrollTop();
  const sliderPos = $('.health-monitoring').position().top
  if (!blockSliderLocking &&
    !isMobile &&
    !isSafari) {
    if (directionDown &&
      (currentPositionTop > lastPositionTop) &&
      (currentPositionTop > Math.round(sliderPos - headerHeight - navHeight - (viewportHeight / 2)))) {
      isLockedToSlider = true
      $('body').addClass('lock');
      slickSlider.slick('slickGoTo', 0);
      $([document.documentElement, document.body]).animate({
        scrollTop: $("#health-scroll").offset().top - navHeight - headerHeight - (((viewportHeight - headerHeight - navHeight - footerHeight) - healthMonitoringHeight) / 2)
      }, 0);
      $('.health-monitoring').css('pointer-events', 'all')
      directionDown = false
      blockLocking(1000)
    }
    else if (!directionDown &&
      (currentPositionTop < lastPositionTop) &&
      (currentPositionTop < (sliderPos - headerHeight - navHeight + (viewportHeight / 2)))) {
      isLockedToSlider = true
      $('body').addClass('lock');
      slickSlider.slick('slickGoTo', 3);
      $([document.documentElement, document.body]).animate({
        scrollTop: $("#health-scroll").offset().top - navHeight - headerHeight - (((viewportHeight - headerHeight - navHeight - footerHeight) - healthMonitoringHeight) / 2)
      }, 0);
      $('.health-monitoring').css('pointer-events', 'all')
      directionDown = true
      blockLocking(1000)
    }
  }
  lastPositionTop = currentPositionTop
});

navBtn.addEventListener('click', function () {
  hamburgerBtn.classList.toggle('show');
  closeBtn.classList.toggle('show');
  menu.classList.toggle('show');
  header.classList.toggle('show');
})

$('#home').on('click', function () {
  if (!isMobile) {
    blockLocking(2000)
    directionDown = true
    isLockedToSlider = false
    slickSlider.slick('slickGoTo', 0);
    $(window).scrollTop(0);
    $('body').removeClass('lock');
  }
  else if (isMobile) {
    $(window).scrollTop(0);
  }
});

$('#lang-pl,#lang-en').on('click', function () {
  if (!isMobile) {
    blockLocking(2000)
    directionDown = true
    isLockedToSlider = false
    slickSlider.slick('slickGoTo', 0);
    $(window).scrollTop(0);
    $('body').removeClass('lock');
  }
  else if (isMobile) {
    $('.header, .menu, .nav__close-btn, .nav__hamburger-btn').toggleClass("show")
    $(window).scrollTop(0);
  }
});

$('#phone-advices').on('click', function () {
  if (!isMobile) {
    blockLocking(2000)
    directionDown = true
    slickSlider.slick('slickGoTo', 0);
    $('body, html').animate({
      scrollTop: $('.phone-advices').offset().top - 60,
    }, 200)
    $('body').removeClass('lock');
  }

  else if (isMobile) {
    $('body, html').animate({
      scrollTop: $('.phone-advices').offset().top - 60,
    }, 200)
    $('.header, .menu, .nav__close-btn, .nav__hamburger-btn').toggleClass("show")
  }
});

$('#health-monitoring').on('click', function () {
  if (isLockedToSlider) return

  if (!isMobile) {
    blockLocking(2000)
    directionDown = true
    $('body, html').animate({
      scrollTop: $("#health-scroll").offset().top - navHeight - headerHeight - (((viewportHeight - headerHeight - navHeight - footerHeight) - healthMonitoringHeight) / 2)
    }, 200)
    slickSlider.slick('slickGoTo', 0);
    $('body').addClass('lock');
    $('.health-monitoring').css('pointer-events', 'all')
  }

  else if (isMobile) {
    $('body, html').animate({
      scrollTop: $('.health-monitoring').offset().top - 60,
    }, 200)
    $('.header, .menu, .nav__close-btn, .nav__hamburger-btn').toggleClass("show")
  }
});

$('#family-profile').on('click', function () {
  if (!isMobile) {
    blockLocking(2000)
    directionDown = false
    slickSlider.slick('slickGoTo', 3);
    $('.footer').removeClass('extend');
    $('body, html').animate({
      scrollTop: $('.family-profile').offset().top - 60,
    }, 200)
    $('body').removeClass('lock');
  }

  else if (isMobile) {
    $('body, html').animate({
      scrollTop: $('.family-profile').offset().top - 60,
    }, 200)
    $('.header, .menu, .nav__close-btn, .nav__hamburger-btn').toggleClass("show")
  }
});

$('#news').on('click', function () {
  if (!isMobile) {
    blockLocking(2000)
    directionDown = false
    slickSlider.slick('slickGoTo', 3);
    $('body, html').animate({
      scrollTop: $('.news').offset().top - 60,
    }, 200)
    $('body').removeClass('lock');
  }

  else if (isMobile) {
    $('body, html').animate({
      scrollTop: $('.news').offset().top - 60,
    }, 200)
    $('.header, .menu, .nav__close-btn, .nav__hamburger-btn').toggleClass("show")
  }
});

$('#access-to-all').on('click', function () {
  if (!isMobile) {
    blockLocking(2000)
    directionDown = false
    slickSlider.slick('slickGoTo', 3);
    $('body, html').animate({
      scrollTop: $('.access-to-all').offset().top - 60,
    }, 200)
    $('body').removeClass('lock');
  }

  else if (isMobile) {
    $('body, html').animate({
      scrollTop: $('.access-to-all').offset().top - 60,
    }, 200)
    $('.header, .menu, .nav__close-btn, .nav__hamburger-btn').toggleClass("show")
  }
});

$('#download').on('click', function () {
  if (!isMobile) {
    blockLocking(2000)
    directionDown = false
    slickSlider.slick('slickGoTo', 3);
    $('body, html').animate({
      scrollTop: $('.access-to-all__btn').offset().top - 60,
    }, 200)
    $('body').removeClass('lock');

    $('.footer').addClass('extend');
  }

  else if (isMobile) {
    $('body, html').animate({
      scrollTop: $('.footer').offset().top - 60,
    }, 200)

    $('.header, .menu, .nav__close-btn, .nav__hamburger-btn').toggleClass("show")
  }
});

$('.bottom-belt').on('click', function () {
  if (!isMobile) {
    blockLocking(2000)
    slickSlider.slick('slickGoTo', 3);
    $('body, html').animate({
      scrollTop: $('.footer').offset().top - 60,
    }, 200)
    $('body').removeClass('lock');
  }
  else if (isMobile) {
    $('body, html').animate({
      scrollTop: $('.footer').offset().top - 60,
    }, 200)
  }
});

$('.main').on('wheel', function (e) {
  $('.footer').removeClass('extend');
});

$('.menu__link--hide-footer').on('click', function () {
  $('.footer').removeClass('extend');
});

$(slickSlider).slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  swipe: false,
  vertical: !isSafari,
  verticalSwiping: true,
  arrows: isSafari,
  dots: !isSafari,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        dots: false,
        swipe: true,
        arrows: true,
        vertical: false,
        verticalSwiping: false
      },
    },
  ],
})
  .on('wheel', (function (e) {
    if (e.originalEvent.deltaY !== 0 &&
      !lockEscapeSlider &&
      !isMobile &&
      !isSafari) {
      e.preventDefault();

      const currentIndex = $(this).slick('slickCurrentSlide');

      if (e.originalEvent.deltaY > 40) {

        if (currentIndex === 3) {
          directionDown = false
          $('.health-monitoring').css('pointer-events', 'none')
          $([document.documentElement, document.body]).animate({
            scrollTop: $("#scroll-family").offset().top - navHeight - headerHeight - 100
          }, 0);

          setTimeout(() => {
            $('body').removeClass('lock');
          }, 1000)

          blockLocking(1000)
          lockEscape(1000, true)
        }
        else {
          $(this).slick('slickNext');
          $('.health-monitoring').css('pointer-events', 'none')
          $('.health-monitoring').css('pointer-events', 'all')
          lockEscape(700, false)
        }
      }
      else if (e.originalEvent.deltaY < -40) {
        if (currentIndex === 0) {
          directionDown = true

          $('.health-monitoring').css('pointer-events', 'none')
          $([document.documentElement, document.body]).animate({
            scrollTop: $("#scroll-questions").offset().top - navHeight - headerHeight - 100
          }, 0);

          setTimeout(() => {
            $('body').removeClass('lock');
          }, 1000)

          blockLocking(1000)
          lockEscape(1000, true)
        }
        else {
          $(this).slick('slickPrev');
          $('.health-monitoring').css('pointer-events', 'none')
          $('.health-monitoring').css('pointer-events', 'all')
          lockEscape(700, false)
        }
      }
    }
  }));

document.querySelector('.phone-advices__btn').onclick = function() {
  document.querySelector('.video-popup').style.display = "block";
  document.querySelector('.phone-advices .video-popup__iframe').src = "https://www.youtube.com/embed/iPoRE---kdw?origin=https://plyr.io&amp;iv_load_policy=3&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1"
};

document.querySelector('.x-btn').onclick = function() {
  document.querySelector('.video-popup').style.display = "none";
  document.querySelector('.video-popup__iframe').removeAttribute('src');
};


document.querySelector('.phone-prescription-btn').onclick = function() {
  document.querySelector('#phone-prescription-popup').style.display = "block";
  document.querySelector('.phone-prescription .video-popup__iframe').src = "https://www.youtube.com/embed/Yx-mt2h3j4o?origin=https://plyr.io&amp;iv_load_policy=3&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1"
};
document.querySelector('.phone-prescription .x-btn').onclick = function() {
  document.querySelector('#phone-prescription-popup').style.display = "none";
  document.querySelector('.phone-prescription .video-popup__iframe').removeAttribute('src');
};


document.querySelector('.documentation-btn').onclick = function() {
  document.querySelector('#documentation-popup').style.display = "block";
  document.querySelector('.documentation-popup .video-popup__iframe').src = "https://www.youtube.com/embed/uGl7IqpiZb4?origin=https://plyr.io&amp;iv_load_policy=3&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1"
};
document.querySelector('.documentation-popup .x-btn').onclick = function() {
  document.querySelector('#documentation-popup').style.display = "none";
  document.querySelector('.documentation-popup .video-popup__iframe').removeAttribute('src');
};


document.querySelector('.recomendations-btn').onclick = function() {
  document.querySelector('#recomendations-popup').style.display = "block";
  document.querySelector('.recomendations-popup .video-popup__iframe').src = "https://www.youtube.com/embed/_ugB5No5IEM?origin=https://plyr.io&amp;iv_load_policy=3&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1"
};
document.querySelector('.recomendations-popup .x-btn').onclick = function() {
  document.querySelector('#recomendations-popup').style.display = "none";
  document.querySelector('.recomendations-popup .video-popup__iframe').removeAttribute('src');
};







